import { Header, Paragraph } from '@dis/components'
import image21 from '@dis/assets/src/images/newTutorial/21.png'
import { styles } from '../styles'

/* eslint-disable react/no-unescaped-entities */
export const ExportToPdf = () => {
  return (
    <>
      <Header marginTop={2} variant="h2">
        1.1 Export to PDF
      </Header>
      <Paragraph marginTop={2} variant="medium" className={styles.subtitleDescription}>
        To export a journey to PDF format, click on the journey's dropdown menu and choose "Export
        to PDF" option – your journey will be downloaded afterwards (and stored in the Downloads
        section).
      </Paragraph>
      <Paragraph marginTop={2} variant="medium" className={styles.subtitleDescription}>
        <img src={image21} width="600" alt="Settings Discovery" />
      </Paragraph>
    </>
  )
}
